import { useAtomValue } from 'jotai'
import React from 'react'
import * as R from 'remeda'

import { useSampleSize } from '~/hooks/useSampleSize'
import { findByPath, pathOr } from '~/utils'

import { countColumnKeysAtom, tabulationResultAtom } from '../atoms'
import { type CountColumnKey, countColumnKeyToId } from '../utils'

type TotalCountData = {
  countColumnKey: CountColumnKey
  count: number
  ratio: number
}

export const useTotalCountsData = (): TotalCountData[] => {
  const countColumnKeys = useAtomValue(countColumnKeysAtom)
  const tabulationResult = useAtomValue(tabulationResultAtom)
  const sampleSize = useSampleSize()

  return React.useMemo(
    () =>
      countColumnKeys.map((countColumnKey) => {
        const count = R.pipe(
          tabulationResult ?? [],
          findByPath(
            'byCustomerAttributeId',
            countColumnKeyToId(countColumnKey),
          ),
          pathOr('result.totalCount', 0),
        )
        const ratio = count / sampleSize

        return { countColumnKey, count, ratio }
      }),
    [countColumnKeys, sampleSize, tabulationResult],
  )
}
